import { apiInstance } from '@api/client';
import { CreateConversationFormDataType } from '@utils/types/messages';
import { toast } from 'react-hot-toast';

export async function postCreateConversation(
  data: CreateConversationFormDataType
): Promise<any> {
  try {
    const response = await apiInstance.post(`/v2/conversations`, data);
    return response.data;
  } catch (error: any) {
    toast.error(error.response.data.message);
    throw error;
  }
}
